module.exports = __webpack_public_path__ + "static/media/superhero.e9637b17.png";